import axios from 'axios';
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
var Api = {
    addCart: function (shopNO, userID, itemList) {
        var _url = '/front/v1/cart/regist/' + shopNO + '/' + userID;
        var items = [];
        for (var i in itemList) {
            var row = {
                item_id: itemList[i].itemID,
                cnt_item: itemList[i].count,
                f_item: 0,
                f_route: 0,
                idx_est_prt: 0,
                stdpc_item_list: itemList[i].stdpc_item_list,
                stdpc_item_list_type1: itemList[i].stdpc_item_list_type1,
                stdpc_item_list_type2: itemList[i].stdpc_item_list_type2,
                stdpc_item_list_type3: itemList[i].stdpc_item_list_type3,
                stdpc_item_list_type4: itemList[i].stdpc_item_list_type4
            };
            items.push(row);
        }
        var param = {
            items: items
        };
        return axios.post(_url, param);
    },
    getMallInfo: function (mall_name) {
        var _url = '/front/v2/minishop/view/?mall_web_user=' + mall_name;
        return axios.get(_url);
    },
    getNoitce: function (b_manager) {
        var _url = '/front/v2/board/main/notice';
        if (b_manager !== undefined)
            _url += '/' + b_manager;
        return axios.get(_url);
    },
};
export default Api;



//////////////////
// WEBPACK FOOTER
// ./src/detail/utils/api.ts
// module id = 213
// module chunks = 0